var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var PasswordVisibilityToggleIconContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    right: 0.6875rem;\n    width: 1.375rem;\n    height: 1.5625rem;\n"], ["\n    position: absolute;\n    right: 0.6875rem;\n    width: 1.375rem;\n    height: 1.5625rem;\n"])));
export var PasswordVisibilityToggleIcon = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 100%;\n    height: 100%;\n    ", ";\n"], ["\n    width: 100%;\n    height: 100%;\n    ", ";\n"])), function (_a) {
    var color = _a.color;
    return !!color && "color: " + color;
});
var templateObject_1, templateObject_2;
